var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"np-checkbox",class:{
		'np-checkbox_disable':_vm.disable,
		'np-checkbox_cir':_vm.shape==='cir',
		'np-checkbox_switch':_vm.shape==='switch',
		'np-checkbox_org':_vm.color==='org'
	}},[_c('input',{attrs:{"disabled":_vm.disable,"type":_vm.radio?'radio':'checkbox'},domProps:{"value":_vm.val,"checked":_vm.checked},on:{"change":_vm.change,"click":_vm.handleClick}}),_c('i',{staticClass:"np-checkbox-style"})])
}
var staticRenderFns = []

export { render, staticRenderFns }